/**
 * This file contains the code for creating or editing the quiz
 */

import React from "react";
import { NotificationManager } from "react-notifications";
import ColorPicker from "../picker/colorpicker";
import {quiztypeenum} from "../enums/quiztypeenum";
import { QuizSetting } from "./quizsetting";
import { LeadGenerationForm } from "./leadgenerationform";
import { LandingPageForm } from "./landingpageform";

import { QueSettingForm } from "./quesettingform";
import { QuizPreview } from "./quizpreview";
import { SeoSettingForm } from "./seosettingform";

var defaultBackgroundImage = "";

export class QuizEditForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabnum: 0,
      tabs: [
        { id: 0, title: "Settings", selected: true },
        { id: 1, title: "Design", selected: false },
        { id: 2, title: "Lead", selected: false },
        { id: 3, title: "Outcome", selected: false },
        { id: 4, title: "Advanced", selected: false },
      ],
      progress: 20,
      user: this.props.user,
      que: null,
      ansArr: null,
      queformActive: false,
      quiz: this.props.quiz,
      minanscount: 2,
      animationType: "slideInRight",
      quetable: {
        header: [["id", "Questions", "Answer Count", "Action"]],
        rowdata: [[]],
      },
      crmdata: null,
      crmprovider: null,
      selectedQue: null,
      showLoaderFlag: false,
      messageUpgrade: "",
      makedisabled: true,
      makedisabledCheckbox: false,
      messageUpgradechecbox: "",
      checkTheme: "",
      bgimg: "",
      quiz: { backgroundimg: "" },
      themeType: "",
      header_bg: "",
      header_text: "",
      header_content_bg: "",
      header_content_text: "",
      button_color: "",
      button_color_text: "",
      footer_bg: "",
      footer_text_color: "",
      enableCustomTheme: true,
      customThemeHideForTransparentTheme: true,
      scrollAddClass: false
    };

    this.nexttab = this.nexttab.bind(this);
    this.prevtab = this.prevtab.bind(this);
    this.onTabClick = this.onTabClick.bind(this);
    this.updateQuiz = this.updateQuiz.bind(this);
    this.updateQue = this.updateQue.bind(this);
    this.updateSelectedQue = this.updateSelectedQue.bind(this);
    this.updateAns = this.updateAns.bind(this);
    this.quizPlay = this.quizPlay.bind(this);
    this.content = this.showAns.bind(this);

    // this.saveQue = this.saveQue.bind(this);
    // this.editQue = this.editQue.bind(this);
    // this.delQue = this.delQue.bind(this);
    this.finish = this.finish.bind(this);
    this.handleQuePreview = this.handleQuePreview.bind(this);
    this.activateQueForm = this.activateQueForm.bind(this);
    this.closeQueForm = this.closeQueForm.bind(this);

    this.showAns = this.showAns.bind(this);
    this.getQuizData = this.getQuizData.bind(this);
    this.changeColorHeaderBg = this.changeColorHeaderBg.bind(this);
    this.changeColorHeaderText = this.changeColorHeaderText.bind(this);
    this.changeColorHeaderContentBg =
      this.changeColorHeaderContentBg.bind(this);
    this.changeColorHeaderContentText =
      this.changeColorHeaderContentText.bind(this);
    this.changeColorButton = this.changeColorButton.bind(this);
    this.changeColorFooterBg = this.changeColorFooterBg.bind(this);
    this.changeColorFooterText = this.changeColorFooterText.bind(this);
    this.getSeoSeetingInfo = this.getSeoSeetingInfo.bind(this);
    this.changeColorButtonText = this.changeColorButtonText.bind(this);

    //this.upgradeMessage = this.upgradeMessage.bind(this);
    //this.checkboxUpgradePlan = this.checkboxUpgradePlan.bind(this);

    // var temptabarr = this.state.tabs;
    // temptabarr.push({title: "Settings", selected: true});
    // temptabarr.push({title: "Design", selected: false});
    // temptabarr.push({title: "Publish", selected: false});

    // this.setState({tabs: temptabarr});
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ quiz: nextProps["quiz"] });
    window.addEventListener('scroll', this.handleScroll);

  }
  handleScroll = () => {
    if (window.scrollY > 100) {
      this.setState({
        scrollAddClass: true
      })
    } else {
      this.setState({
        scrollAddClass: false
      })
    }
  };

  componentWillUnmount() {
    // Clean up the listener when the component unmounts
    window.removeEventListener('scroll', this.handleScroll);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
    if (this.props.match.params != null && this.props.match.params.id) {
      var quizid = this.props.match.params.id;
      this.setState({ quizid }, this.getQuizData);
    } else {
      var quiz = {};
      quiz.randomque = "0";
      quiz.randomans = "0";
      quiz.title = "";
      quiz.description = "";
      quiz.quizwelcomemsg = "";
      quiz.quizfootermsg = "";
      // quiz.theme = "theme1";
      quiz.theme2 = "theme2";
      quiz.quizthankyoumsg = "";
      quiz.quizemailmsg = "";
      quiz.quizoffermsg = "";
      quiz.quizscoremsg = "";
      quiz.quizbtntxt = "";
      quiz.quizofferbtntxt = "Schedule Now";
      quiz.scoretype = "Percentage";
      quiz.seoSeetingInformation = ["hhhhhh"];

      quiz.quizmetadata = null;
      quiz.theme_type = localStorage.getItem("selected_theme_id");
      // /uploads/theme_first_bg.png
      if (this.state.quiz.backgroundimg == "") {
        const query = new URLSearchParams(this.props.location.search);
        const selected_theme = query.get("theme");
        const selected_theme_type = query.get("quiztype");

        if (selected_theme == "1" && selected_theme_type == quiztypeenum.graded_quiz) {
          defaultBackgroundImage = "/assets/templates/theme_first_bg.png";
          quiz.backgroundimg = "/assets/templates/theme_first_bg.png";
          // defaultBackgroundImage = '/uploads/theme_first_bg.png';
          // quiz.backgroundimg = '/uploads/theme_first_bg.png';
          //quiz.theme = "theme1";
        } else if (selected_theme == "2" && selected_theme_type == quiztypeenum.graded_quiz) {
          defaultBackgroundImage = "/assets/templates/theme_second_bg.jpg";
          quiz.backgroundimg = "/assets/templates/theme_second_bg.jpg";
          // defaultBackgroundImage = '/uploads/theme_first_bg.png';
          // quiz.backgroundimg = '/uploads/theme_second_bg.jpg';
          //quiz.theme = "theme2";
        } else if (selected_theme == "1" && selected_theme_type == quiztypeenum.personality_quiz) {
          defaultBackgroundImage = "/assets/templates/personality_quiz_1.jpg";
          quiz.backgroundimg = "/assets/templates/personality_quiz_1.jpg";
          //quiz.theme = "theme4";
        } else if (selected_theme == "2" && selected_theme_type == quiztypeenum.personality_quiz) {
          defaultBackgroundImage = "/assets/templates/personality_quiz_2.jpg";
          quiz.backgroundimg = "/assets/templates/personality_quiz_2.jpg";
          //quiz.theme = "theme5";
        }
        var quiztype = query.get("quiztype");
        quiz.quiztype = quiztype;
      } else {
        quiz.backgroundimg = "";
        //quiz.theme = "";
      }

      quiz.theme = "custom_theme";
      quiz.enableCustomTheme = true;
      quiz.bgimg = "";
      quiz.collectuseremailflag = 1;
      quiz.is_enable_player_result = 0;
      quiz.que = [];
      this.setState({ quiz }, this.createQuiz);
    }
  }
  getSeoSeetingInfo(seoSeetingData) {
    var quiz = this.state.quiz;
    quiz["meta_title"] = seoSeetingData["meta_title"];
    quiz["meta_description"] = seoSeetingData["meta_description"];
    quiz["google_analytics"] = seoSeetingData["google_analytics"];
    quiz["crm_tag"] = seoSeetingData["crm_tag"];

    this.setState({
      quiz: quiz,
    });
  }
  componentWillMount() {
    // this.setState({
    //     quiz: {
    //         backgroundimg: 'uploads/smb-06803c47a981856d9fc628243a886769-undefined-theme_second_bg.jpg',
    //     },
    // })
    const query = new URLSearchParams(this.props.location.search);
    const selected_theme = query.get("theme");
    const selected_theme_type = query.get("quiztype");
    localStorage.setItem("selected_theme_id", selected_theme);
    this.setState({
      themeType: selected_theme,
    });
    if (selected_theme == "1" && selected_theme_type == quiztypeenum.graded_quiz) {
      this.setState({
        themeType: "uploads/theme_first_bg.png",
      });
    } else if (selected_theme == "2" && selected_theme_type == quiztypeenum.graded_quiz) {
      this.setState({
        themeType: "uploads/theme_second_bg.jpg",
      });
    } else if (selected_theme == "1" && selected_theme_type == quiztypeenum.personality_quiz) {
      this.setState({
        themeType: "uploads/personality_quiz_1.jpg",
      });
    } else if (selected_theme == "2" && selected_theme_type == quiztypeenum.personality_quiz) {
      this.setState({
        themeType: "uploads/personality_quiz_2.jpg",
      });
    }
  }

  createQuiz() {
    var quiz = this.state.quiz;
    quiz.quizstatus = "draft";

    var jsonStr = JSON.stringify(quiz);
    jsonStr = encodeURIComponent(jsonStr);
    var postdata =
      "userid=" +
      this.state.user.userid +
      "&type=quiz&action=savequiz" +
      "&params=" +
      jsonStr;

    //var queryurl = this.props.qzbasepath + "getdata";
    var queryurl = this.props.basepath + "quiz/savequiz";
    var self = this;
    fetch(queryurl, {
      method: "post",
      credentials: "include",
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: postdata,
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      self.setState({ showLoaderFlag: false });
      if (response && response.status == 200 && response.data) {
        quiz["quizid"] = response.data.quizid;
        self.setState({ quiz });
      }else{
        NotificationManager.error("Server error: " + response.message);
      }
    }).catch(err=>{
      NotificationManager.error("Server error: " , err.message)
    });
  }

  modifyQuiz() {
    var quiz = this.state.quiz;
    let theme_colors = [
      { header_bg: this.state.header_bg.hex },
      { header_text: this.state.header_text.hex },
      { header_content_bg: this.state.header_content_bg.hex },
      { header_content_text: this.state.header_content_text.hex },
      { footer_bg: this.state.footer_bg.hex },
      { footer_text_color: this.state.footer_text_color.hex },
      { button_color: this.state.button_color.hex },
      { button_color_text: this.state.button_color_text.hex },
    ];
    quiz.theme_color = JSON.stringify(theme_colors);
    // if(quiz.quiztype == quiztypeenum.category_quiz_multiple_personality){
    //   var metadata = quiz.quizmetadata;
    //   quiz.quizmetadata = JSON.stringify(metadata);
    // }

    var jsonStr = JSON.stringify(quiz);
    jsonStr = encodeURIComponent(jsonStr);
    var postdata =
      "userid=" +
      this.state.user.userid +
      "&type=quiz&action=savequiz" +
      "&params=" +
      jsonStr;
    var queryurl = this.props.basepath + "quiz/savequiz";
    var self = this;
    fetch(queryurl, {
      method: "post",
      credentials: "include",
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: postdata,
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      self.setState({ showLoaderFlag: false });
      if (response && response.status == 200 && response.data) {
        self.setState(quiz);
      }else{
        NotificationManager.error("Server error: " + response.message);
      }
    }).catch(err=>{
      NotificationManager.error("Server error: " , err.message)
    });
  }

  getQuizData() {
    var flag = false;
    var quizid = this.state.quizid;
    //var queryurl = this.props.basepath + "index.php/quizzer/qzcreate/1";
    var queryurl = this.props.basepath + "quiz/getdata";
    var postdata =
      "flag=" +
      flag +
      "&quizid=" +
      quizid +
      "&userid=" +
      this.state.user.userid;
    var self = this;
    fetch(queryurl, {
      method: "post",
      credentials: "include",
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: postdata,
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      if(response && response.status==200 && response.data){
        var quizobj = response.data;
        quizobj["enableCustomTheme"] = true;
        
        // if (quizobj.theme == "custom_theme") {
        //   quizobj["enableCustomTheme"] = true;
        // }
        quizobj.personalityArr = null;
        if ((quizobj.quiztype == quiztypeenum.personality_quiz || quizobj.quiztype == quiztypeenum.multiple_personality_quiz) && quizobj.quizmetadata) {
          quizobj.personalityArr = JSON.parse(quizobj.quizmetadata);
        }
        if ((quizobj.quiztype == quiztypeenum.category_quiz_multiple_personality || quizobj.quiztype == quiztypeenum.category_graded_quiz_with_personality)  && quizobj.quizmetadata) {
          var metadata = JSON.parse(quizobj.quizmetadata);
          if(metadata.personalityArr){
            quizobj.personalityArr = JSON.parse(metadata.personalityArr);
          }
          if(metadata.quecategory){
            quizobj.quecategory = JSON.parse(metadata.quecategory);
          }
        }

        // for theme colors select
        var header_bg = { hex: "" };
        var header_text = { hex: "" };
        var header_content_bg = { hex: "" };
        var header_content_text = { hex: "" };
        var footer_bg = { hex: "" };
        var footer_text_color = { hex: "" };
        var button_color = { hex: "" };
        var button_color_text = { hex: "" };
        if (quizobj != null && quizobj.theme_color != null && quizobj.theme_color != "") {
          let theme_colors = JSON.parse(quizobj.theme_color);
          header_bg.hex = theme_colors[0].header_bg;
          header_text.hex = theme_colors[1].header_text;
          header_content_bg.hex = theme_colors[2].header_content_bg;
          header_content_text.hex = theme_colors[3].header_content_text;
          footer_bg.hex = theme_colors[4].footer_bg;
          footer_text_color.hex = theme_colors[5].footer_text_color;
          button_color.hex = theme_colors[6].button_color;
          button_color_text.hex = theme_colors[7]
            ? theme_colors[7].button_color_text
            : "";
        }
        var makeFalseCustomThemehideForTransparent = true;
        if (quizobj.emailformtype == null) {
          quizobj.emailformtype = "standard";
        }
        if (quizobj.landingformtype == null) {
          quizobj.landingformtype = "standard";
        }

        self.setState({
          quiz: quizobj, header_bg, header_text, header_content_bg, header_content_text,footer_bg, footer_text_color, button_color,
          button_color_text: button_color_text ? button_color_text : "",
          customThemeHideForTransparentTheme:true,
        },() => {
          self.updateQuiz(quizobj);
        });
      }else{
        NotificationManager.error("Server error: " + response.message);
      }
    }).catch(err=>{
      NotificationManager.error("Server error: " , err.message)
    });
  }

  finish(e) {
    var draftflag = e.target.getAttribute("data-draft");
    //var jsoncrmdata = JSON.stringify(this.state.crmdata);
    var quizdata = this.state.quiz;

    if (quizdata.title == null || quizdata.title == "") {
      alert("Quiz title cannot be empty");
      return false;
    }
    if (quizdata.que == null || quizdata.que.length == 0) {
      alert(
        "There are no questions in this quiz. Please add atleast one question before publishing the quiz."
      );
      return false;
    }

    //if(quizdata.crmdata == null)
    // {
    //     quizdata.crmdata = jsoncrmdata;
    // }
    this.saveQuiz(draftflag);
  }

  activateQueForm() {
    this.setState({ queformActive: true });
  }

  closeQueForm() {
    this.setState({ queformActive: false });
  }

  updateQuiz(quiz) {
    this.setState({ quiz: quiz });
  }

  saveQuiz(saveAsDraft) {
    this.setState({
      showLoaderFlag: true,
      loaderMessage: "Saving Quiz Please Wait...",
    });

    var selectedquiz = this.state.quiz;
    let theme_colors = [
      { header_bg: this.state.header_bg.hex },
      { header_text: this.state.header_text.hex },
      { header_content_bg: this.state.header_content_bg.hex },
      { header_content_text: this.state.header_content_text.hex },
      { footer_bg: this.state.footer_bg.hex },
      { footer_text_color: this.state.footer_text_color.hex },
      { button_color: this.state.button_color.hex },
      { button_color_text: this.state.button_color_text.hex },
    ];
    selectedquiz.theme_color = JSON.stringify(theme_colors);
    // generate quiz title slug from title
    var getQuizTitleSlug = this.state.quiz.title
      .toLowerCase()
      .replace(/ /g, "-")
      .replace(/[^\w-]+/g, "");

    selectedquiz["quiz_slug"] = getQuizTitleSlug;

    selectedquiz["quizarray"] = null;

    if (saveAsDraft) {
      selectedquiz.quizstatus = "draft";
    } else {
      selectedquiz.quizstatus = "published";
    }

    if (selectedquiz.que == null || selectedquiz.que.length == 0) {
      selectedquiz.que_count = 0;
    } else {
      selectedquiz.que_count = selectedquiz.que.length;
    }
    selectedquiz.company = "Socialmbuzz";
    if (
      selectedquiz.quiztype == quiztypeenum.personality_quiz ||
      selectedquiz.quiztype == quiztypeenum.graded_quiz_with_personality ||
      selectedquiz.quiztype == quiztypeenum.weighted_graded_quiz ||
      selectedquiz.quiztype == quiztypeenum.multiple_personality_quiz
    ) {
      selectedquiz.quizmetadata = JSON.stringify(selectedquiz.personalityArr);
    } else if (selectedquiz.quiztype == quiztypeenum.category_quiz_multiple_personality || selectedquiz.quiztype == quiztypeenum.category_graded_quiz_with_personality) {
      // if(selectedquiz.quizmetadata == null){
      //   selectedquiz.quizmetadata = {};
      // }
      var metadata = {personalityArr:JSON.stringify(selectedquiz.personalityArr), quecategory:JSON.stringify(selectedquiz.quecategory)};
      //selectedquiz.quizmetadata.quecategory = JSON.stringify(selectedquiz.quecategory);
      selectedquiz.quizmetadata = JSON.stringify(metadata);

    } else {
      selectedquiz.quizmetadata = null;
    }
    selectedquiz.description = selectedquiz.quizwelcomemsg;

    var jsonStr = JSON.stringify(selectedquiz);
    jsonStr = encodeURIComponent(jsonStr);
    var postdata =
      "userid=" +
      this.state.user.userid +
      "&type=quiz&action=savequiz" +
      "&params=" +
      jsonStr;
    var queryurl = this.props.basepath + "quiz/savequiz";
    var self = this;

    fetch(queryurl, {
      method: "post",
      credentials: "include",
      headers: {
        "Content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
      body: postdata,
    }).then(function (response) {
      return response.json();
    }).then(function (response) {
      self.setState({ showLoaderFlag: false });
      if (response && response.status==200 && response.data) {
        if (saveAsDraft) {
          NotificationManager.success(
            "Quiz Saved",
            "Your quiz has been successfully saved as draft. Please ensure to publish it before sharing it in your network."
          );
        } else {
          // swal(
          //   "Quiz Saved",
          //   "Your quiz has been successfully saved and published!!",
          //   "success"
          // );
          NotificationManager.success(
            "Quiz Saved",
            "Your quiz has been successfully saved and published."
          );
          self.props.history.push({pathname:"/app/Quiz/Share/" + response.data.quizid,
          state:{quizType:selectedquiz.quiztype, quizTitle:response.data.quiz_slug, quizid:response.data.quizid,quizTitleWithoutSlug:self.state.quiz.title}});
        }
      }
      else{
        NotificationManager.error("Server error: ",response.message)
      }
    }).catch(err=>{
      NotificationManager.error("Server error: " , err.message)
    });
  }

  updateQue(que) {
    this.setState({ que });
  }
  updateSelectedQue(selectedQue) {
    this.setState({ selectedQue: selectedQue });
  }

  updateAns(ansArr) {
    this.setState({ ansArr: ansArr });
  }

  islasttab() {
    return this.state.tabnum == this.state.tabs.length - 1;
  }

  isfirsttab() {
    return this.state.tabnum == 0;
  }

  onTabClick(event) {
    var tabid = event.target.getAttribute("dataid");
    var tabnum = this.state.tabnum;
    var progressVal = this.state.progress;
    var tempqueArr = this.state.quetable;
    var selectedQue = this.state.selectedQue;
    if (tabid != tabnum) {
      tabnum = tabid;
      var index = parseInt(tabnum) + 1;
      progressVal = ((1 * index) / this.state.tabs.length) * 100;
      if (tabnum == 1) {
        var tempArr = [];
        if (
          this.state.quiz == null ||
          this.state.quiz.que == null ||
          this.state.quiz.que.length == 0
        ) {
          tempArr[0] = [0, "There are no questions in this quiz!!", null, null];
        } else {
          //this.state.quiz.que.map(function(item, index) {
          Object.values(this.state.quiz.que).map(function (item, counter) {
            var jsonansobj = JSON.parse(item.jsonans);
            tempArr[counter] = [
              counter,
              item.title,
              jsonansobj.length,
              item.action,
            ];
          }, this);
        }

        tempqueArr.rowdata = tempArr;
        selectedQue = this.state.quiz.que[0];
      }

      this.setState({
        quetable: tempqueArr,
        selectedQue,
        tabnum,
        progress: progressVal,
        animationType: "slideInRight",
      });
    }
  }

  nexttab() {
    if (this.state.quiz.title == "") {
      NotificationManager.error(
        "Validation Error",
        "Quiz title cannot be empty"
      );
      return false;
    }

    if (this.state.tabnum == 2) {
      if (this.state.quiz.quiztype == quiztypeenum.graded_quiz) {
        if (
          !this.state.quiz.quizemailformcode &&
          this.state.quiz.emailformtype == "custom"
        ) {
          NotificationManager.error(
            "Validation Error",
            "Enter code for lead generation form."
          );
          return false;
        } else if (
          !this.state.quiz.landingformurl &&
          this.state.quiz.landingformtype == "custom"
        ) {
          NotificationManager.error(
            "Validation Error",
            "Enter url for custom landing page."
          );
          return false;
        }
      }

      if (
        this.state.quiz.quiztype == quiztypeenum.personality_quiz ||
        this.state.quiz.quiztype == quiztypeenum.multiple_personality_quiz || 
        this.state.quiz.quiztype == quiztypeenum.category_quiz_multiple_personality
      ) {
        // if empty Please enter url for landing page for personalities
        if (this.state.quiz.landingformtype == "custom") {
          let checkPersonalityFormUrl = false;
          this.state.quiz.personalityArr.map(function (item) {
            if (!item.landingformurl || item.landingformurl == undefined) {
              checkPersonalityFormUrl = true;
            }
          });
          if (checkPersonalityFormUrl) {
            NotificationManager.error(
              "Validation Error",
              "Enter url for custom landing page."
            );
            return false;
          }
        }

        // if Empty Please enter html code for email form for personalities
        if (this.state.quiz.emailformtype == "custom") {
          let checkPersonalityEmailformcode = false;
          this.state.quiz.personalityArr.map(function (item) {
            if (
              !item.quizemailformcode ||
              item.quizemailformcode == undefined
            ) {
              checkPersonalityEmailformcode = true;
            }
          });
          if (checkPersonalityEmailformcode) {
            NotificationManager.error(
              "Validation Error",
              "Please enter html code for email form for personalities."
            );
            return false;
          }
        }
      }
    }
    if (this.state.quiz.quiztype == quiztypeenum.personality_quiz ||this.state.quiz.quiztype == quiztypeenum.multiple_personality_quiz) {
      let checkPersonalityTitleValidation = false;
      let checkPersonalityDescriptionValidation = false;

      // check if quiz desc not added
      if (this.state.quiz.quizwelcomemsg == "") {
        NotificationManager.error("Validation Error","Welcome Message is required.");
        return false;
      }
      // check if personality not added on blank template
      if (
        this.state.quiz.personalityArr == "undefined" ||
        this.state.quiz.personalityArr == "" ||
        this.state.quiz.personalityArr == null
      ) {
        NotificationManager.error(
          "Validation Error",
          "Personalities is required."
        );
        return false;
      }
      this.state.quiz.personalityArr.map(function (item) {
        if (item.title == "") {
          checkPersonalityTitleValidation = true;
        }
        if (item.description == "") {
          checkPersonalityDescriptionValidation = true;
        }
      });
      if (!this.state.quiz.personalityArr) {
        //swal("Personality", "You have to add min two personality", "info");
        NotificationManager.error(
          "Validation Error",
          "Please add atleast two personalities."
        );
        return false;
      } else if (checkPersonalityTitleValidation) {
        NotificationManager.error(
          "Validation Error",
          "Personality title is required."
        );
        return false;
      } else if (checkPersonalityDescriptionValidation) {
        NotificationManager.error(
          "Validation Error",
          "Personality description is required."
        );
        return false;
      }
    }
    if (this.state.quiz.quiztype == quiztypeenum.category_quiz_multiple_personality || this.state.quiz.quiztype == quiztypeenum.category_graded_quiz_with_personality) {
      let checkPersonalityTitleValidation = false;
      let checkPersonalityDescriptionValidation = false;
      let checkQueCategoryTitleValidation = false;
      let checkQueCategoryDescriptionValidation = false;

      // check if quiz desc not added
      if (this.state.quiz.quizwelcomemsg == "") {
        NotificationManager.error("Validation Error","Welcome Message is required.");
        return false;
      }
      // check if personality not added on blank template
      if (this.state.quiz.personalityArr == "undefined" || this.state.quiz.personalityArr == "" || this.state.quiz.personalityArr == null) {
        NotificationManager.error("Validation Error","Personalities is required.");
        return false;
      }
      if (this.state.quiz.quecategory == "undefined" || this.state.quiz.quecategory == "" || this.state.quiz.quecategory == null) {
        NotificationManager.error("Validation Error","Question category is required.");
        return false;
      }

      this.state.quiz.personalityArr.map(function (item) {
        if (item.title == "") {
          checkPersonalityTitleValidation = true;
        }
        if (item.description == "") {
          checkPersonalityDescriptionValidation = true;
        }
      });

      this.state.quiz.quecategory.map(function (item) {
        if (item.title == "") {
          checkQueCategoryTitleValidation = true;
        }
        if (item.description == "") {
          checkQueCategoryDescriptionValidation = true;
        }
      });


      if (!this.state.quiz.personalityArr) {
        NotificationManager.error("Validation Error", "Please add atleast two personalities.");
        return false;
      } else if (checkPersonalityTitleValidation) {
        NotificationManager.error("Validation Error","Personality title is required.");
        return false;
      } else if (checkPersonalityDescriptionValidation) {
        NotificationManager.error("Validation Error","Personality description is required.");
        return false;
      }

      if (!this.state.quiz.quecategory) {
        NotificationManager.error("Validation Error", "Please add atleast two question category.");
        return false;
      } else if (checkQueCategoryTitleValidation) {
        NotificationManager.error("Validation Error","Question title is required.");
        return false;
      } else if (checkQueCategoryDescriptionValidation) {
        NotificationManager.error("Validation Error","Question description is required.");
        return false;
      }
    }

    var index = parseInt(this.state.tabnum) + 1;
    // if (index <= 1) {
    //   this.setState({
    //     customThemeHideForTransparentTheme: false,
    //   });
    // }
    var tempqueArr = this.state.quetable;

    if (index == 1) {
      var tempArr = [];
      if (
        this.state.quiz == null ||
        this.state.quiz.que == null ||
        this.state.quiz.que.length == 0
      ) {
        tempArr[0] = [0, "There are no questions in this quiz!!", null, null];
      } else {
        //this.state.quiz.que.map(function(item, index) {
        Object.values(this.state.quiz.que).map(function (item, index) {
          var jsonansobj = JSON.parse(item.jsonans);
          tempArr[index] = [index, item.title, jsonansobj.length, item.action];
        }, this);
      }

      tempqueArr.rowdata = tempArr;
    }

    var progressVal = this.state.progress + (1 / this.state.tabs.length) * 100;

    this.setState(
      {
        quetable: tempqueArr,
        tabnum: index,
        progress: progressVal,
        animationType: "slideInRight",
      },
      this.modifyQuiz
    );
  }

  prevtab() {
    var index = this.state.tabnum - 1;
    // if (index == 0) {
    //   this.setState({
    //     customThemeHideForTransparentTheme: true,
    //   });
    // }
    var progressVal = this.state.progress - (1 / this.state.tabs.length) * 100;
    this.setState({
      tabnum: index,
      progress: progressVal,
      animationType: "slideInLeft",
    });
  }

  rendertabs() {
    return this.state.tabs.map(function (tabItem, counter) {
      return (
        <div
          key={counter}
          className={`ba-wizard-navigation ${
            this.state.tabnum == "" + counter ? "active" : ""
          }`}
          data-index={counter}
        >
          <div
            className={
              tabItem.title == "Landing Page" ? "col-md-9" : "col-md-11"
            }
            dataid={tabItem.id}
            onClick={this.onTabClick}
          >
            {tabItem.title}
          </div>
          <div className="col-md-2 col-xs-12">
            {tabItem.title == "Landing Page" ? (
              <button className="btn btn-sm" onClick={this.finish}>
                Publish
              </button>
            ) : (
              <button
                className="btn btn-sm"
                style={{ visibility: "hidden" }}
              ></button>
            )}
          </div>
        </div>
      );
    }, this);
  }
  //show answers in preview when hover on rows in question table
  showAns() {
    var content = "";
    var que = this.state.selectedQuePreview;

    var tempquetype = que == null ? "MCSA" : que.quetype;
    var jsonans = null;
    var jsonansimg = null;

    if (que != null) {
      jsonans = que.jsonans;
      jsonansimg = que.jsonansimg;
    }
    var ans = null;
    var anscount = 0;
    if (jsonans != null) {
      ans = JSON.parse(jsonans);
      anscount = ans.length;
    }

    var img = null;
    if (jsonansimg != null) {
      img = JSON.parse(jsonansimg);
    }

    if (tempquetype == null || tempquetype == "" || tempquetype == "MCSA") {
      content = (
        <div>
          <div className="col-md-8 col-md-offset-2 m-t-sm">
            <div id="divans1" className="">
              <button
                style={{ width: 100 + "%", whiteSpace: "normal" }}
                className="btn qzwcmsg"
              >
                {ans == null
                  ? "Sample Ans Title"
                  : ans[0] == null || ans[0] == ""
                  ? "Sample Ans Title"
                  : ans[0]}
                <img
                  className={
                    img == null || img[0] == null || img[0] == "" ? "hide" : ""
                  }
                  src={img == null ? "" : img[0]}
                  style={{ height: 48, width: 48 }}
                />
              </button>
            </div>
          </div>
          <div className="col-md-8 col-md-offset-2 m-t-sm">
            <div id="divans2" className="">
              <button
                style={{ width: 100 + "%", whiteSpace: "normal" }}
                className="btn qzwcmsg"
              >
                {ans == null
                  ? "Sample Ans Title"
                  : ans[1] == null || ans[1] == ""
                  ? "Sample Ans Title"
                  : ans[1]}
                <img
                  className={
                    img == null || img[1] == null || img[1] == "" ? "hide" : ""
                  }
                  src={img == null ? "" : img[1]}
                  style={{ height: 48, width: 48 }}
                />
              </button>
            </div>
          </div>
          <div
            className={`col-md-8 col-md-offset-2 m-t-sm ${
              anscount > this.state.minanscount ? "" : "hide"
            }`}
          >
            <div id="divans3" className="">
              <button
                style={{ width: 100 + "%", whiteSpace: "normal" }}
                className="btn qzwcmsg"
              >
                {ans == null
                  ? "Sample Ans Title"
                  : ans[2] == null || ans[2] == ""
                  ? "Sample Ans Title"
                  : ans[2]}
                <img
                  className={
                    img == null || img[2] == null || img[2] == "" ? "hide" : ""
                  }
                  src={img == null ? "" : img[2]}
                  style={{ height: 48, width: 48 }}
                />
              </button>
            </div>
          </div>
          <div
            className={`col-md-8 col-md-offset-2 m-t-sm ${
              anscount > this.state.minanscount + 1 ? "" : "hide"
            }`}
            style={{ marginTop: 10 }}
          >
            <div id="divans4" className="">
              <button
                style={{ width: 100 + "%", whiteSpace: "normal" }}
                className="btn qzwcmsg"
              >
                {ans == null
                  ? "Sample Ans Title"
                  : ans[3] == null || ans[3] == ""
                  ? "Sample Ans Title"
                  : ans[3]}
                <img
                  className={
                    img == null || img[3] == null || img[3] == "" ? "hide" : ""
                  }
                  src={img == null ? "" : img[3]}
                  style={{ height: 48, width: 48 }}
                />
              </button>
            </div>
          </div>
        </div>
      );
    } else if (tempquetype == "TF") {
      content = (
        <div>
          <div className="col-md-8 col-md-offset-2 m-t-sm">
            <div id="divans1" className="">
              <button
                style={{ width: 100 + "%", whiteSpace: "normal" }}
                className="btn qzwcmsg"
              >
                {ans == null
                  ? "Sample Ans Title"
                  : ans[0] == null || ans[0] == ""
                  ? "Sample Ans Title"
                  : ans[0]}
                <img
                  className={
                    img == null || img[0] == null || img[0] == "" ? "hide" : ""
                  }
                  src={img == null ? "" : img[0]}
                  style={{ height: 48, width: 48 }}
                />
              </button>
            </div>
          </div>
          <div className="col-md-8 col-md-offset-2 m-t-sm">
            <div id="divans2" className="">
              <button
                style={{ width: 100 + "%", whiteSpace: "normal" }}
                className="btn qzwcmsg"
              >
                {ans == null
                  ? "Sample Ans Title"
                  : ans[1] == null || ans[1] == ""
                  ? "Sample Ans Title"
                  : ans[1]}
                <img
                  className={
                    img == null || img[1] == null || img[1] == "" ? "hide" : ""
                  }
                  src={img == null ? "" : img[1]}
                  style={{ height: 48, width: 48 }}
                />
              </button>
            </div>
          </div>
        </div>
      );
    }

    return content;
  }

  handleQuePreview(event) {
    if (this.state.quiz != null) {
      var queid = event.target.parentElement.getAttribute("data-id");
      var queArr = this.state.quiz["que"];
      var que = Object.values(queArr);
      if (que != null && que.length != 0) {
        //&& queArr.length < queid)
        //var selectedQue = queArr[queid - 1];
        var selectedQue = que.filter((element) => element.queid == queid);
        if (selectedQue != null && selectedQue.length > 0) {
          this.setState({ selectedQue: selectedQue[0] });
        }
      }
    }
  }

  quizPlay(event) {
    var quizData = this.state.quiz;
    var quizidp = JSON.stringify(quizData);
    var quizurl =
      "https://app.quizzes4leads.com/quiz_preview?qObject=" + quizidp;

    window.open(quizurl);
  }
  changeColorHeaderBg(header_bg) {
    this.setState({
      header_bg: header_bg,
    });
  }
  changeColorHeaderText(header_text) {
    this.setState({
      header_text: header_text,
    });
  }
  changeColorHeaderContentBg(header_content_bg) {
    this.setState({
      header_content_bg: header_content_bg,
    });
  }
  changeColorHeaderContentText(header_content_text) {
    this.setState({
      header_content_text: header_content_text,
    });
  }
  changeColorButton(button_color) {
    this.setState({
      button_color: button_color,
    });
  }
  changeColorButtonText(button_color_text) {
    this.setState({
      button_color_text: button_color_text,
    });
  }

  changeColorFooterBg(footer_bg) {
    this.setState({
      footer_bg: footer_bg,
    });
  }
  changeColorFooterText(footer_text_color) {
    this.setState({
      footer_text_color: footer_text_color,
    });
  }

  render() {
    let theme_colors = this.state.quiz.theme_color
      ? JSON.parse(this.state.quiz.theme_color)
      : "";
    return (
      <div className="">
        <div className="qzpanel-body">
          <div className="col-md-6">
            <div
              className="col-md-12"
              style={{ backgroundColor: "white", padding: "15px" }}
            >
              <div
                className="ba-wizard-navigation-container"
                style={{
                  position: "absolute",
                  paddingTop: 3,
                  fontSize: 14,
                  fontWeight: 700,
                }}
              >
                {this.rendertabs()}
              </div>
              <div
                className="progress ba-wizard-progress"
                style={{ marginTop: 25 }}
              >
                <div
                  className="progress-bar progress-bar-quizzer active"
                  role="progressbar"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  style={{ width: this.state.progress + "%" }}
                ></div>
              </div>
              <div className="steps">
                <section
                  className={`step animated aaa ${this.state.animationType} ${
                    this.state.tabnum != "0" ? "hide" : ""
                  }`}
                >
                  <QuizSetting
                    selectedQue={this.state.selectedQue}
                    quiz={this.state.quiz}
                    user={this.state.user}
                    updateQuiz={this.updateQuiz}
                    basepath={this.props.basepath}
                  />
                </section>
                <section
                  className={`step animated ${this.state.animationType} ${
                    this.state.tabnum != "1" ? "hide" : ""
                  }`}
                >
                  <QueSettingForm
                    quiz={this.state.quiz}
                    user={this.state.user}
                    updateQuiz={this.updateQuiz}
                    updateQue={this.updateQue}
                    updateSelectedQue={this.updateSelectedQue}
                    updateAns={this.updateAns}
                    queformActive={this.state.queformActive}
                    selectedQue={this.state.selectedQue}
                    quetable={this.state.quetable}
                    activateQueForm={this.activateQueForm}
                    closeQueForm={this.closeQueForm}
                    handleQuePreview={this.handleQuePreview}
                    basepath={this.props.basepath}
                    saveQuiz={this.saveQuiz}
                  />
                </section>
                <section
                  className={`step animated ${this.state.animationType} ${
                    this.state.tabnum != "2" ? "hide" : ""
                  }`}
                >
                  <LeadGenerationForm
                    quiz={this.state.quiz}
                    user={this.state.user}
                    updateQuiz={this.updateQuiz}
                    basepath={this.props.basepath}
                  />
                </section>
                <section
                  className={`step animated ${this.state.animationType} ${
                    this.state.tabnum != "3" ? "hide" : ""
                  }`}
                  >
                    <LandingPageForm
                    quiz={this.state.quiz}
                    user={this.state.user}
                    updateQuiz={this.updateQuiz}
                    basepath={this.props.basepath}
                  />
                </section>
                
                <section
                  className={`step animated ${this.state.animationType} ${
                    this.state.tabnum != "4" ? "hide" : ""
                  }`}
                >
                  <SeoSettingForm
                    quiz={this.state.quiz}
                    sendSeoSeetingData={this.getSeoSeetingInfo}
                  />
                </section>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <nav>
                  <ul className="pager ba-wizard-pager">
                    <li className="previous">
                      <button
                        className={`btn-normal ${
                          this.state.queformActive || this.isfirsttab()
                            ? "hide"
                            : ""
                        }`}
                        type="button"
                        onClick={this.prevtab}
                      >
                        <span aria-hidden="true">←</span> Previous
                      </button>
                    </li>
                    {this.islasttab() ? (
                      <li className="next">
                        <button
                          className="btn-normal"
                          type="button"
                          onClick={this.finish}
                        >
                          Finish
                        </button>
                      </li>
                    ) : (this.islasttab() || this.state.queformActive) ==
                      false ? (
                      <li className="next">
                        <button
                          className="btn-normal"
                          type="button"
                          onClick={this.nexttab}
                        >
                          Next
                          <span aria-hidden="true">→</span>
                        </button>
                      </li>
                    ) : null}
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          {/* {this.state.themeType} */}

          <div className={`col-md-6 scroll-sticky ${this.state.scrollAddClass ? 'sticky' : ''}`} style={{ backgroundColor: "white" }}>
            <div className="row">
              <div className="ba-wizard-navigation-container">
                <div className="ba-wizard-navigation active">Quiz Preview</div>
              </div>
            </div>
            {this.state.tabnum == "0" ? (
              <div
                className="col-md-12 color-picker-wrapper"
                style={{
                  display:
                    this.state.customThemeHideForTransparentTheme == false
                      ? "none"
                      : "",
                }}
              >
                <div className="col-item-block">
                  <div className="col-item-sub">
                    <div className="header-block"> Header</div>
                    <div className="background-text-block">
                      <div className="col-item">
                        {!this.state.quiz.enableCustomTheme ? (
                          <div className="content-padding"> Background</div>
                        ) : (
                          ""
                        )}
                        <ColorPicker
                          picker_label="Background"
                          enableCustomTheme={this.state.quiz.enableCustomTheme}
                          scolor={
                            theme_colors.header_bg
                              ? theme_colors[0].header_bg
                              : this.state.header_bg.hex
                          }
                          onSelectLanguage={this.changeColorHeaderBg}
                        />
                        <i
                          style={{ left: "-10%" }}
                          data-tip="Select custom theme to pick your own colors."
                          className="fa fa-info-circle"
                        ></i>
                        <br></br>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-item-block">
                  <div className="col-item-sub">
                    <div className="header-block">Content </div>
                    <div className="background-text-block">
                      <div className="col-item">
                        {!this.state.quiz.enableCustomTheme ? (
                          <div className="content-padding"> Background</div>
                        ) : (
                          ""
                        )}
                        <ColorPicker
                          picker_label="Background"
                          enableCustomTheme={this.state.quiz.enableCustomTheme}
                          scolor={
                            theme_colors.header_content_bg
                              ? theme_colors[2].header_content_bg
                              : this.state.header_content_bg.hex
                          }
                          onSelectLanguage={this.changeColorHeaderContentBg}
                        />
                        <i
                          style={{ left: "-10%" }}
                          data-tip="Select custom theme to pick your own colors."
                          className="fa fa-info-circle"
                        ></i>
                        <br></br>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-item-block">
                  <div className="col-item-sub">
                    <div className="header-block">Button </div>
                    <div className="background-text-block">
                      <div className="col-item">
                        {!this.state.quiz.enableCustomTheme ? (
                          <div className="content-padding">Background</div>
                        ) : (
                          ""
                        )}
                        <ColorPicker
                          picker_label="Background"
                          enableCustomTheme={this.state.quiz.enableCustomTheme}
                          scolor={
                            theme_colors.button_color
                              ? theme_colors[6].button_color
                              : this.state.button_color.hex
                          }
                          onSelectLanguage={this.changeColorButton}
                        />
                        <i
                          data-tip="Select custom theme to pick your own colors."
                          className="fa fa-info-circle"
                        ></i>
                        <br></br>
                      </div>
                      <div className="col-item">
                        {!this.state.quiz.enableCustomTheme ? (
                          <div className="content-padding"> Text</div>
                        ) : (
                          ""
                        )}
                        <ColorPicker
                          picker_label="Text"
                          enableCustomTheme={this.state.quiz.enableCustomTheme}
                          scolor={
                            theme_colors.button_color_text
                              ? theme_colors[7].button_color_text
                              : this.state.button_color_text.hex
                          }
                          onSelectLanguage={this.changeColorButtonText}
                        />
                        <i
                          data-tip="Select custom theme to pick your own colors."
                          className="fa fa-info-circle"
                        ></i>
                        <br></br>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-item-block">
                  <div className="col-item-sub">
                    <div className="header-block"> Footer </div>
                    <div className="background-text-block">
                      <div className="col-item">
                        {!this.state.quiz.enableCustomTheme ? (
                          <div className="content-padding">Background </div>
                        ) : (
                          ""
                        )}
                        <ColorPicker
                          picker_label="Background"
                          enableCustomTheme={this.state.quiz.enableCustomTheme}
                          scolor={
                            theme_colors.footer_bg
                              ? theme_colors[4].footer_bg
                              : this.state.footer_bg.hex
                          }
                          onSelectLanguage={this.changeColorFooterBg}
                        />
                        <i
                          style={{ left: "-10%" }}
                          data-tip="Select custom theme to pick your own colors."
                          className="fa fa-info-circle"
                        ></i>
                        <br></br>
                      </div>
                      {/* <div className="col-item">
                      {!this.state.quiz.enableCustomTheme ? (
                        <div className="content-padding"> Text</div>
                      ) : (
                        ""
                      )}
                      <ColorPicker
                        picker_label="Text"
                        enableCustomTheme={this.state.quiz.enableCustomTheme}
                        scolor={
                          theme_colors.footer_text_color
                            ? theme_colors[5].footer_text_color
                            : this.state.footer_text_color.hex
                        }
                        onSelectLanguage={this.changeColorFooterText}
                      />
                      <br></br>
                    </div> */}
                    </div>
                  </div>
                </div>
              </div>
            ) : null}
            <div
              className="col-md-12"
              style={{
                backgroundImage: `url(${
                  this.state.quiz.backgroundimg == ""
                    ? this.state.themeType
                    : this.state.quiz.backgroundimg
                    ? this.state.quiz.backgroundimg
                    : this.state.quiz.quizbkgroundimage
                })`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                backgroundRepeat: "no-repeat",
                padding: "20px",
                paddingTop: "20",
              }}
            >
              <QuizPreview
                tabnum={this.state.tabnum}
                header_bg={this.state.header_bg}
                header_text={this.state.header_text}
                header_content_bg={this.state.header_content_bg}
                header_content_text={this.state.header_content_text}
                button_color={this.state.button_color}
                button_color_text={this.state.button_color_text}
                footer_bg={this.state.footer_bg}
                footer_text_color={this.state.footer_text_color}
                quiz={this.state.quiz}
                queformActive={this.state.queformActive}
                que={this.state.que}
                selectedQue={this.state.selectedQue}
                basepath={this.props.basepath}
                user={this.state.user}
              />
            </div>
          </div>
        </div>
        {this.state.showLoaderFlag ? (
          <div
            style={{
              width: 100 + "%",
              height: 100 + "%",
              background: "rgb(0,0,0,0.5)",
              position: "fixed",
            }}
          >
            <div className="loader"></div>
          </div>
        ) : (
          <div className="loader" style={{ display: "none" }}></div>
        )}
        {this.state.showLoaderFlag ? (
          <div className="loaderSaveQuiz">{this.state.loaderMessage}</div>
        ) : (
          <div className="loaderMessage" style={{ display: "none" }}></div>
        )}
      </div>
    );
  }
}





